import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { EventFragment } from "../../../../../../__generated__/graphql";
import { cn } from "../../../../../../lib/utils";
import { useMemo } from "react";

export default function EventSelection({
  event,
  isSelected,
  handleEventClick,
  selectedEventRef,
}: {
  event: EventFragment;
  isSelected: boolean;
  handleEventClick: (event: EventFragment) => void;
  selectedEventRef: React.RefObject<HTMLDivElement>;
}) {
  const imageUrl = event.eventLocation?.location.photoUrls?.[0] || undefined;

  const selectedStyle = "bg-card border border-accent";
  const dateCard = useMemo(() => {
    const eventDate = new Date(event.startDate);

    // Get day, month and year separately
    const day = format(eventDate, "d", { locale: fr });
    const month = format(eventDate, "MMMM", { locale: fr });
    const year = format(eventDate, "yyyy", { locale: fr });

    return (
      <div className="w-20 h-20 bg-[#FAF9F4] rounded-md p-2 flex flex-col items-center justify-center">
        <div className="text-2xl font-bold text-dark">{day}</div>
        <div className="text-sm text-dark">{month}</div>
        <div className="text-sm text-dark">{year}</div>
      </div>
    );
  }, [event.startDate]);

  return (
    <div
      ref={isSelected ? selectedEventRef : null}
      className={cn(
        "relative flex items-center justify-between p-4 rounded-md cursor-pointer flex-shrink-0 w-[300px] border border-border overflow-hidden",
        isSelected ? selectedStyle : "bg-dark"
      )}
      style={
        imageUrl
          ? {
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : undefined
      }
      onClick={() => handleEventClick(event)}
    >
      {imageUrl && (
        <div className="absolute inset-0 bg-black/60 transition-colors" />
      )}
      <div className="relative flex-1 min-w-0 mr-4">
        <div className="text-sm text-accent truncate">{event.name}</div>
        <h1 className="truncate">{event.eventLocation?.location?.label}</h1>
        <div className="text-sm text-secondary truncate">
          {event.eventLocation?.location?.city}
        </div>
      </div>

      <div className="relative">{dateCard}</div>
    </div>
  );
}
